import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import { Tabs, Tab } from "@mui/material";
import BillPaymentReportTable from "components/billpaymentreport/BillPaymentReportTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import BillPaymentReportServices from "services/BillPaymentReportServices";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { FiRefreshCcw } from "react-icons/fi";
// import BillPaymentReportDrawer from "components/drawer/BillPaymentReportDrawer";
// import MainDrawer from "components/drawer/MainDrawer";
// import DeleteModal from "components/modal/DeleteModal";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import { useLocation } from "react-router-dom";
import { useRef } from "react";

const BillPaymentReport = () => {
  const location = useLocation();
  // const {
  //   state: { adminInfo },
  // } = useContext(AdminContext);
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tab, setTab] = useState(0);
  const [error, setError] = useState(false);
  const [billpaymentreportData, setBillPaymentReportData] = useState([]);
  // const [paymentStatus, setPaymentStatus] = useState("unpaid");
  const [status, setStatus] = useState(false);
  const [exportingData, setExportingData] = useState([]);

  const {
    billpaymentreportRef,
    dataTable,
    serviceData,
    handleSubmitBillPaymentReport,
    currentPage,
  } = useFilter(billpaymentreportData, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const initialLoadRef = useRef(true);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const typeStr = params.get("type");
    if (typeStr) {
      const parsedType = Number(typeStr);
      if (!isNaN(parsedType) && parsedType >= 1 && parsedType <= 3) {
        setTab(parsedType - 1);
      }
    }

    const startStr = params.get("start");
    const endStr = params.get("end");

    let needsRefresh = false;

    if (startStr && endStr) {
      // URL-provided dates
      const [sd, sm, sy] = startStr.split("-");
      const [ed, em, ey] = endStr.split("-");

      const startDate = new Date(`${sy}-${sm}-${sd}`);
      const endDate = new Date(`${ey}-${em}-${ed}`);

      if (!isNaN(startDate) && !isNaN(endDate)) {
        setSearchStartDate(startDate);
        setSearchEndDate(endDate);
        needsRefresh = true;
      }
    }
    //  ONLY FIRST LOAD → TODAY
    else if (initialLoadRef.current && typeStr) {
      const today = new Date();
      setSearchStartDate(today);
      setSearchEndDate(today);
      needsRefresh = true;
    }

    if (needsRefresh) {
      setIsUpdate(true);
    }

    initialLoadRef.current = false;
  }, [location.search]);

  // const formattedDates = {
  // 	start_date: searchstartDate ? formatDate(searchstartDate) : '',
  // 	end_date: searchendDate ? formatDate(searchendDate) : '',
  // };

  useEffect(() => {
    const fetchBillPaymentReport = async () => {
      setLoading(true);

      try {
        let response;
        if (tab === 0) {
          let payload = {
            from: searchstartDate ? formatDate(searchstartDate) : "",
            to: searchendDate ? formatDate(searchendDate) : "",

            type: 1,
          };

          response =
            await BillPaymentReportServices.billpaymentreportRequestList(
              payload,
            );
        } else if (tab === 1) {
          let payload = {
            from: searchstartDate ? formatDate(searchstartDate) : "",
            to: searchendDate ? formatDate(searchendDate) : "",

            type: 2,
          };

          response =
            await BillPaymentReportServices.billpaymentreportRequestList(
              payload,
            );
        } else if (tab === 2) {
          var payload = {
            from: searchstartDate ? formatDate(searchstartDate) : "",
            to: searchendDate ? formatDate(searchendDate) : "",

            type: 3,
          };

          response =
            await BillPaymentReportServices.billpaymentreportRequestList(
              payload,
            );
          // console.log("bill payment data from response",response);
        }
        const updatedData =
          response?.data?.map(
            ({
              id,
              ref_no,
              client_name,
              start_date,
              end_date,
              bill_amount,
              tds,
              vendor_name,
              paid_amount,
              total_trip_advance_paid,
              payment_date,
              paid_status,
              bill_adjusted_status,
              bill_approval_status,
              bill_verify_satus,
              bill_added_date,
              client_id,

              va_id,
              ...rest
            }) => ({
              id,
              ref_no,
              client_name,
              start_date,
              end_date,
              bill_amount,
              tds,
              vendor_name,
              paid_amount,
              total_trip_advance_paid,
              payment_date,
              paid_status,
              bill_adjusted_status,
              bill_approval_status,
              bill_verify_satus,
              bill_added_date,
              client_id,

              va_id,
              ...rest,
            }),
          ) || [];
        // console.log("data in updatedata", updatedData);

        setBillPaymentReportData(updatedData);
        setStatus(response?.status);
        setLoading(false);

        const finalData = response?.data?.map((item, index) => {
          const tripAdvanceHistory =
            item.payment_history
              ?.filter((payment) => payment.type === "Trip Advance")
              ?.map((payment) => {
                const adjustments = payment.adjustments
                  ?.map(
                    (adj) =>
                      `${adj.client_name} - ${adj.ref_no} - ₹${adj.adjusted_amount}`,
                  )
                  .join("\n");

             return `Payment Type: ${payment.payment_type}

			Amount: ₹${payment.amount}

			Adjusted Amount: ₹${payment.adjusted_amount}

			Paid Date: ${new Date(payment.paid_date).toLocaleDateString("en-GB", {
       		day: "2-digit",
        	month: "short",
        	year: "numeric",
      		})}

				Adjustments:
				${adjustments || "-"}`;
              })
              .join("\n\n") || "-";
          return {
            "SI.No": index + 1,
            "Reference No": item.ref_no,
            "Client Name": item.client_name,
            "Start Date": item.start_date,
            "End Date": item.end_date,
            "Arrival City": item.arrival,
            "Vendor Name": item.vendor_name || "-",
            "Trip Date": item.trip_date
              ? item.trip_date.replace(/<br\s*\/?>/gi, "\n")
              : "",
            "Bill Amount": item.bill_amount || "-",
            TDS: item.tds,
            "Trip Advance": item.total_trip_advance_paid || "-",
            "Trip Advance History": tripAdvanceHistory,
            "Remaining Payable Amount": item.remaining_individual_amt || "-",
            Status:
              item.report_status || (item.paid_status == 0 ? "Unpaid" : "Paid"),
          };
        });
        setExportingData(finalData);
        // console.log("billreport finaldata", finalData);
      } catch (error) {
        setLoading(false);
        setError(true);
        // console.error('Error fetching billpaymentreport:', error);

        //notifyError("Failed to fetch billpaymentreport. Please try again later.");
      }
    };
    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }
    fetchBillPaymentReport();

    // eslint-disable-next-line
  }, [tab, isUpdate, searchstartDate, searchendDate, id_employee]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bill payment report" && perm.view === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bill payment report" && perm.export === 1,
      );

  const handleRefresh = () => {
    setSearchStartDate(null);
    setSearchEndDate(null);
    setIsUpdate(true);
  };

  const getTabName = () => {
    if (tab === 0) return "UnPaid";
    if (tab === 1) return "Paid";
    if (tab === 2) return "All";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="End Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={billpaymentreportRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitBillPaymentReport}
                  />
                </div>

                {hideExport && (
                  <div className="items-center">
                    <ExportDataXlsx
                      title="billPayment"
                      exportDataXlsx={exportingData}
                      fileNames={`BillPayment_${getTabName()}`}
                      startDate={searchstartDate}
                      endDate={searchendDate}
                    />
                  </div>
                )}

                <div>
                  <Button
                    className="rounded-md h-10 px-8"
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    Search
                  </Button>
                </div>

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unpaid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Paid"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="All"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-scroll "
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Ref No.</TableCell>
                        <TableCell>Client Name </TableCell>
                        <TableCell>Travel Date </TableCell>
                        {/* <TableCell>Arrival</TableCell> */}
                        <TableCell>Vendor Name</TableCell>
                        {/* <TableCell>Trip Date</TableCell> */}
                        <TableCell>Bill Amount</TableCell>
                        <TableCell>TDS</TableCell>
                        <TableCell>Trip Advance</TableCell>
                        <TableCell>
                          {tab === 1
                            ? "Remaining Paid Amount"
                            : "Remaining Payable Amount"}
                        </TableCell>

                        <TableCell>Status</TableCell>
                        <TableCell>Payment History</TableCell>
                      </tr>
                    </TableHeader>
                    <BillPaymentReportTable
                      billpaymentreport={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      tab={tab}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no BillPayments." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default BillPaymentReport;
